import React, { useEffect, useContext, useState, useRef } from 'react';
import { Button, Container, Dropdown, Grid, Header, Icon, Image, Input, Label, Message, Modal, Segment, Table } from 'semantic-ui-react';
import AuthContext from '../context/authContext';
import useWindowDimensions from '../hooks/useWindowDimensions';
import { getKeyJwtTG, getlinkplayerprofile, getZoomT, LiveIcon3, noGoldIsActive, noSubIsActive } from '../myfunctions';
import { ConnectWS } from '../ConnectWS';
import { useToasts } from 'react-toast-notifications';

import LogoTeamLigaGenerator from '../assets/tglogov6_small.png';
import ShowImgAvatar from './ShowImgAvatar';
import useCheckUserIsDemo from '../hooks/useCheckUserIsDemo';
import { useTranslation } from 'react-i18next';
import EditLeagueMatchDetailsExMatcheTs from './EditLeagueMatchDetailsExType/EditLeagueMatchDetailsExMatcheTs';
import { confirmAlert } from 'react-confirm-alert';
import { useHistory } from 'react-router-dom';
import EditLeagueGlobalStats from './EditLeagueMatchDetailsExType/EditLeagueGlobalStats';
import AIGetStatsEX from './AIGetStatsEX';
import EditLeagueMatchDetailsExMatcheVersion2 from './EditLeagueMatchDetailsExType/EditLeagueMatchDetailsExMatcheVersion2';
import { checkIsLiveMatch } from '../leagueFuntions';
import EditLeagueMatchDetailsExMatcheFiba from './EditLeagueMatchDetailsExType/EditLeagueMatchDetailsExMatcheFiba';
import { QRCodeSVG } from 'qrcode.react';
import JWT from 'expo-jwt';


function EditLeagueMatchDetailsEx(props) {
  let history = useHistory();
  const { addToast } = useToasts();
  const authContext = useContext(AuthContext);
  const { width, height } = useWindowDimensions();// eslint-disable-line no-unused-vars
  const [open, setOpen] = useState(false)
  const [match_details_ex, setmatch_details_ex] = useState(null)
  const [match_details_ex_type, setmatch_details_ex_type] = useState(0)
  const [loading, setloading] = useState(false)
  const isDemo = useCheckUserIsDemo()
  const [isAS, setisAS] = useState(false)
  const [globalCFGStats, setGlobalCFGStats] = useState(false)
  const [isLiveMatch, setisLiveMatch] = useState(false)
  const [scoreMatches, setscoreMatches] = useState({ set_match_score: false })

  const { t } = useTranslation();
  function checkSubIsActiv() {
    try {
 
      if (isDemo) {
        setisAS(true)
      } else if (props.panelMembers === true) {
        setisAS(true)
      } else if (authContext.user.subscription_info && authContext.user.subscription_info.subscription_extended >= 0 && authContext.user.subscription_info.subscription_active) {
        setisAS(true)
      } else if (props.tournament_free === 2 && props.ttype !== 'LEAGUE') {
        setisAS(true)
      } else if (props?.tournamentJson?.organizer_subscription_extended!==null && props?.tournamentJson?.organizer_subscription_extended >= 0) {
        setisAS(true)
      } else {
        setisAS(false)
      }
    } catch (e) {
      setisAS(false)
    }
  }

  function getModyfiJsonStats(props) {
    try {
      let isScore = props.openModalmatch_details_ex.open && props.openModalmatch_details_ex.row && props.openModalmatch_details_ex.row.member1_score !== null ? true : false

      if (props.openModalmatch_details_ex.onlyView === 0) {
        return <Button size="tiny" floated='left' color='orange' style={{ marginBottom: 10 }} onClick={() => isScore ? addToast("Konfiguracja dozwolona tylko na pojedynku, który nie ma uzupełnionego wyniku", { appearance: 'info' }) : setGlobalCFGStats(true)}>GLOBALNA KONFIGURACJA STATYSTYK</Button>
      }
      return ""
    } catch (e) {
      return ""
    }
  }


  function checkIsEnabledSaveScore() {
    try {
      if (props.ttype.includes("CUP_")) {
        return false
      }
      return true
    } catch (e) {
      return false
    }
  }

  let interval2 = useRef(null);

  function ClearAllInterval() {
    clearInterval(interval2.current)
  }

  useEffect(() => {
   
    if (isLiveMatch && props.openModalmatch_details_ex.open) {
      ClearAllInterval()
      interval2.current = setInterval(() => {
        GetCurrentDataInLive()
      }, 10000);
    } else {
      ClearAllInterval()
    }
    return () => {
      ClearAllInterval()
    }; // use effect cleanup to set flag false, if unmounted
  }, [isLiveMatch, JSON.stringify(props.openModalmatch_details_ex)])// eslint-disable-line react-hooks/exhaustive-deps


  function GetCurrentDataInLive() {
    try {

      let match_id = props.openModalmatch_details_ex.row.subtournament_league_match_id
      let member1_id = props.openModalmatch_details_ex.row.match_member1_id
      let member2_id = props.openModalmatch_details_ex.row.match_member2_id
      ConnectWS("/generator/checkMatchExists", null, { match_id: match_id, member1_id: member1_id, member2_id: member2_id }, function (response, logout) {
        if (logout === 1) {

        } else if (response && response.status && Number(response.status) === 200) {
          if (response.data.match_data.match_details_ex) {
            setmatch_details_ex(response.data.match_data.match_details_ex)
            let jsonUpdateScore = getScoreMatch(response.data.match_data.match_details_ex)
            if (jsonUpdateScore && jsonUpdateScore.set_match_score) {
              setscoreMatches(jsonUpdateScore)
            }

          }
        } else {

        }

      });
    } catch (e) {

    }
  }

  useEffect(() => {
    
    if (props.openModalmatch_details_ex.open) {
      setOpen(props.openModalmatch_details_ex.open)
      try {
        if (props.openModalmatch_details_ex.onlyView === 1 && props.panelMembers !== true) {
          setisLiveMatch(checkIsLiveMatch(props.openModalmatch_details_ex.row.match_date, props.openModalmatch_details_ex.row.last_modify_ts, props.openModalmatch_details_ex.row.match_details_ex))
        } else {
          setisLiveMatch(false)
        }
      } catch (e) {

      }


      setGlobalCFGStats(false)
      setmatch_details_ex(null)
      setmatch_details_ex_type(0)

      checkSubIsActiv()


      if (props.openModalmatch_details_ex.row.match_details_ex) {


        try {
          prestart(JSON.parse(JSON.stringify(props.openModalmatch_details_ex.row.match_details_ex)))
        } catch (e) {

        }

      }

    } else {
      setOpen(props.openModalmatch_details_ex.open)
    }
    return () => {
      setscoreMatches({ set_match_score: false })
    }; // use effect cleanup to set flag false, if unmounted
  }, [JSON.stringify(props.openModalmatch_details_ex)])// eslint-disable-line react-hooks/exhaustive-deps
  //

  function getMatchDetails(match_member1_id, match_member2_id) {
    try {
      if (props.openModalmatch_details_ex && props.openModalmatch_details_ex.open && props.openModalmatch_details_ex.row.match_details) {
        let tmparr = JSON.parse(props.openModalmatch_details_ex.row.match_details).score
        let tmparr2 = []

        tmparr.forEach((row1) =>
          tmparr2.push(" " + row1[match_member1_id] + ":" + row1[match_member2_id])
        )
        return <span style={{ fontSize: 18 }}>{tmparr2.toString()}</span>
      } else {
        return ""
      }


    } catch (e) {
      console.log(e)
      return ""
    }

  }

  function prestart(match_details_ex) {

    if (match_details_ex) {

      let match_details_extmp = JSON.parse(JSON.stringify(match_details_ex))

      // definiowane inne statystyki meczowe
      if (match_details_extmp.matche_ts) {

        setmatch_details_ex(match_details_extmp)
        setmatch_details_ex_type(1)
        return
      } else if (match_details_extmp.version) {

        setmatch_details_ex(match_details_extmp)
        setmatch_details_ex_type(match_details_extmp.version)
        return
      } else if (match_details_extmp.fiba) {
        setmatch_details_ex(match_details_extmp)
        setmatch_details_ex_type("fiba")
        return
      }



      for (const [key] of Object.entries(match_details_extmp.members).sort((a, b) => a[1].sort - b[1].sort)) {

        if (match_details_extmp.members[key].team1_id === null) {
          match_details_extmp.members[key].team1_id = props.openModalmatch_details_ex.row.member1_id
        }
        match_details_extmp.members[key].team1_members = startCreateJsonTeam(props.openModalmatch_details_ex.row.member1_id, match_details_extmp.members[key].team1_members)

        if (match_details_extmp.members[key].team2_id === null) {
          match_details_extmp.members[key].team2_id = props.openModalmatch_details_ex.row.member2_id
        }
        match_details_extmp.members[key].team2_members = startCreateJsonTeam(props.openModalmatch_details_ex.row.member2_id, match_details_extmp.members[key].team2_members)
      }


      setmatch_details_ex(match_details_extmp)
      setmatch_details_ex_type(0)


    }
  }

  function startCreateJsonTeam(team_id, team2_members) {
    try {

      // szukanie druzyny
      let team = []
      if (props.openModalmatch_details_ex.st.members && props.openModalmatch_details_ex.st.members.length > 0) {

        props.openModalmatch_details_ex.st.members.forEach((row) => {
          if (row.member_id === team_id) {
            team.push(...row.members_list)
          }
        })
      }

      if (team.length > 0) {

        var obj = {};
        team.forEach((row) => {

          obj[row.member_team_id] = { value: team2_members && team2_members[row.member_team_id] && team2_members[row.member_team_id].value ? team2_members[row.member_team_id].value : null }
        })

        return { ...obj }
      } else {
        return null
      }

    } catch (e) {
      console.log(e)
      addToast("Wystąpił błąd!", { appearance: 'error' });
      return null
    }

  }

  function getValueOther(team_id, json, team_nr) {
    if (json.team1_id === null && team_nr === 1) {
      return null
    } else if (json.team2_id === null && team_nr === 2) {
      return null
    } else if (json.team1_id !== null && team_nr === 1) {
      return json.team1_member
    } else if (json.team2_id !== null && team_nr === 2) {
      return json.team2_member
    }
  }

  function updateJsonOrder(value, key, team_nr, team_id) {

    let jsonTmp = { ...match_details_ex }

    if (team_nr === 1) {
      jsonTmp.others[key].team1_id = team_id
      jsonTmp.others[key].team1_member = value
    } else if (team_nr === 2) {
      jsonTmp.others[key].team2_id = team_id
      jsonTmp.others[key].team2_member = value
    } else {

    }
    setmatch_details_ex({ ...jsonTmp })

  }

  function getOthersInfo(team_id, team_nr) {
    try {
      const rows = [];

      if (match_details_ex && match_details_ex.others) {
        for (const [key, value] of Object.entries(match_details_ex.others).sort((a, b) => a[1].sort - b[1].sort)) {

          if (props.openModalmatch_details_ex.onlyView) {
            rows.push(
              <div><Icon color='grey' name={value.icon} />{t("stats." + value.name)}: {getValueOther(team_id, value, team_nr) ? getValueOther(team_id, value, team_nr) : <i>{t("BrakDanych")}</i>}</div>
            )
          } else {
            if (value.type === 'inputnumber') {
              rows.push(
                <div><Icon color='grey' name={value.icon} />{t("stats." + value.name)}: <Input type="number" value={getValueOther(team_id, value, team_nr)} onChange={(e, d) => updateJsonOrder(d.value, key, team_nr, team_id)} /></div>
              )
            } else {
              rows.push(
                <div><Icon color='grey' name={value.icon} />{t("stats." + value.name)}: <Input value={getValueOther(team_id, value, team_nr)} onChange={(e, d) => updateJsonOrder(d.value, key, team_nr, team_id)} /></div>
              )
            }
          }

        }
        return <Segment textAlign='left'>{rows}</Segment>
      }
    } catch (e) {
      console.log(e)
    }

  }


  function getAllMembers(team_id, member_img_file, team_nr) {
    try {

      let team = []
      if (props.openModalmatch_details_ex.st.members && props.openModalmatch_details_ex.st.members.length > 0) {

        props.openModalmatch_details_ex.st.members.forEach((row) => {
          if (row.member_id === team_id) {
            team.push(...row.members_list)
          }
        })
      }
      const rows = [];
      const cells = [];
      for (const [key, value] of Object.entries(match_details_ex.members).sort((a, b) => a[1].sort - b[1].sort)) {
        rows.push(
          <Table.HeaderCell textAlign='center' width={1} style={{ lineHeight: "12px", textTransform: "uppercase" }}>{t("stats." + value.name)}</Table.HeaderCell>
        )
        cells.push(
          { ...value, id: key }
        )

      }
      if (team.length > 0) {
        return <><div style={{ overflowY: "auto", width: "100%" }} >
          <Table size='small' celled striped compact unstackable >
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell width={1} textAlign='center'>LP</Table.HeaderCell>
                <Table.HeaderCell textAlign='center' style={{ lineHeight: "12px" }}><figure className='imgPlayer'><ShowImgAvatar urlpic={member_img_file} mtype={"USER"} /><figcaption> {t("WidokTurnieju.zawodnik")}</figcaption></figure></Table.HeaderCell>
                {rows}
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {team.map((row, i) =>
                <Table.Row key={i}  >
                  <Table.Cell textAlign='center'>{i + 1}</Table.Cell>

                  <Table.Cell><figure className='imgPlayer'><ShowImgAvatar urlpic={row.member_img_file} mtype={"0"} msize={"mini"} /><figcaption>{getlinkplayerprofile(null, row.member_name, 0, 14)}</figcaption></figure></Table.Cell>
                  {cells.map((row1, j) =>
                    <Table.Cell width={1} textAlign='center'>{getValuRow(row.member_team_id, row1, team_id)}</Table.Cell>
                  )}
                </Table.Row>
              )}

            </Table.Body>
          </Table>
        </div>

          {getOthersInfo(team_id, team_nr)}
        </>
      } else {
        return <Message>{t("WidokTurnieju.brak_przypisanych_zawodnikow")}</Message>
      }

    } catch (e) {
      return ""
    }
  }

  /*
  const optionsBool = [
    { key: 'TAK', text: 'TAK', value: true },
    { key: 'NIE', text: 'NIE', value: false },
  ]
       <Select compact options={optionsBool} value={row1.team2_members[member_team_id].value === null ? false : row1.team2_members[member_team_id].value} onChange={(e, d) => updateJson(member_team_id, row1, team_id, d.value)} />
       
*/
  const optionsBoolCards = [
    { key: 'yellow', text: '', value: 'yellow', image: { avatar: true, src: process.env.REACT_APP_PUBLIC_URL + "/img/icon/yellowc.png" } },
    { key: 'red', text: '', value: 'red', image: { avatar: true, src: process.env.REACT_APP_PUBLIC_URL + "/img/icon/redc.png" }, },
    { key: 'yellow-red', text: '', value: 'yellow-red', image: { avatar: true, src: process.env.REACT_APP_PUBLIC_URL + "/img/icon/cardsyr.png" }, },
    { key: 'brak', text: 'Brak', value: null }
  ]

  function getCardsImg(value) {
    if (value === "yellow") {
      return <Image style={{ height: 20, margin: "0 auto" }} src={process.env.REACT_APP_PUBLIC_URL + "/img/icon/yellowc.png"} />
    } else if (value === "red") {
      return <Image style={{ height: 20, margin: "0 auto" }} src={process.env.REACT_APP_PUBLIC_URL + "/img/icon/redc.png"} />
    } else if (value === "yellow-red") {
      return <Image style={{ height: 20, margin: "0 auto" }} src={process.env.REACT_APP_PUBLIC_URL + "/img/icon/cardsyr.png"} />
    } else {
      return ""
    }

  }

  function getIconGoals(value) {
    try {
      let arr = []
      if (Number(value) > 0) {
        for (let i = 0; i < Number(value); i++) {
          arr.push(<Icon name="soccer" />)
        }
        return arr
      }
      return ""
    } catch (e) {
      return value
    }
  }

  function getValuRow(member_team_id, row1, team_id) {
    try {
      if (row1.team1_id === team_id) {
        if (props.openModalmatch_details_ex.onlyView) {
          return row1.type === "boolimagecard" ? getCardsImg(row1.team1_members[member_team_id].value) : row1.type === "inputboolicon" ? row1.team1_members[member_team_id].value === true ? <Icon color='yellow' name={row1.icon} /> : "" : row1.type === "inputbool" ? row1.team1_members[member_team_id].value === null ? <Icon name="x" color='grey' title="NIE" /> : row1.team1_members[member_team_id].value === true ? <Icon name="check" color='green' title="TAK" /> : <Icon name="x" color='grey' title="NIE" /> : row1.id === "points_scored_goals" ? getIconGoals(row1.team1_members[member_team_id].value) : row1.team1_members[member_team_id].value
        } else if (row1.type === "inputbool" || row1.type === "inputboolicon") {
          return row1.team1_members[member_team_id].value ? <Icon className='cursorPointer' name="check" color='green' onClick={() => updateJson(member_team_id, row1, team_id, false)} /> : <Icon name="x" className='cursorPointer' onClick={() => updateJson(member_team_id, row1, team_id, true)} />

        } else if (row1.type === "boolimagecard") {
          return <Dropdown inline options={optionsBoolCards} value={row1.team1_members[member_team_id].value} onChange={(e, d) => updateJson(member_team_id, row1, team_id, d.value)} />
        } else {
          return <Input style={{ width: row1.type === "inputnumber" ? 80 : 120 }} type={row1.type === "inputnumber" ? "number" : row1.type.type === "inputurl" ? "url" : "text"} value={row1.team1_members[member_team_id].value} onChange={(e, d) => updateJson(member_team_id, row1, team_id, d.value)} />
        }

      } else if (row1.team2_id === team_id) {
        if (props.openModalmatch_details_ex.onlyView) {
          return row1.type === "boolimagecard" ? getCardsImg(row1.team2_members[member_team_id].value) : row1.type === "inputboolicon" ? row1.team2_members[member_team_id].value === true ? <Icon color='yellow' name={row1.icon} /> : "" : row1.type === "inputbool" ? row1.team2_members[member_team_id].value === null ? <Icon name="x" color='grey' title="NIE" /> : row1.team2_members[member_team_id].value === true ? <Icon name="check" color='green' title="TAK" /> : <Icon name="x" color='grey' title="NIE" /> : row1.id === "points_scored_goals" ? getIconGoals(row1.team2_members[member_team_id].value) : row1.team2_members[member_team_id].value
        } else if (row1.type === "inputbool" || row1.type === "inputboolicon") {
          return row1.team2_members[member_team_id].value ? <Icon className='cursorPointer' name="check" color='green' onClick={() => updateJson(member_team_id, row1, team_id, false)} /> : <Icon name="x" className='cursorPointer' onClick={() => updateJson(member_team_id, row1, team_id, true)} />
        } else if (row1.type === "boolimagecard") {
          return <Dropdown inline options={optionsBoolCards} value={row1.team2_members[member_team_id].value} onChange={(e, d) => updateJson(member_team_id, row1, team_id, d.value)} />
        } else {
          return <Input style={{ width: row1.type === "inputnumber" ? 80 : 120 }} type={row1.type === "inputnumber" ? "number" : row1.type.type === "inputurl" ? "url" : "text"} value={row1.team2_members[member_team_id].value} onChange={(e, d) => updateJson(member_team_id, row1, team_id, d.value)} />
        }

      } else {
        return "?"
      }

    } catch (e) {
      return "?"
    }
  }

  function updateJson(member_team_id, row1, team_id, value) {

    let jsonTmp = { ...match_details_ex }

    if (row1.team1_id === team_id) {
      jsonTmp.members[row1.id].team1_members[member_team_id].value = value
    } else if (row1.team2_id === team_id) {
      jsonTmp.members[row1.id].team2_members[member_team_id].value = value
    } else {

    }

    setmatch_details_ex({ ...jsonTmp })

  }

  function exitModal() {

    props.setopenModalmatch_details_ex({ open: false, row: null, onlyView: 1, st: null })
    setOpen(false)
  }


  

  function saveDBData(mtype) {
    let match_id = props.openModalmatch_details_ex.row.subtournament_league_match_id ? props.openModalmatch_details_ex.row.subtournament_league_match_id : props.openModalmatch_details_ex.row.match_id
    setloading(true)
    let jsonUpdateScore = { set_match_score: false }
    if (mtype === 2) {
      jsonUpdateScore = getScoreMatch(match_details_ex)
      setscoreMatches(jsonUpdateScore)
    }
    ConnectWS(props.panelMembers === true ? "/external_panel/setMatchDetailsEx" : "/generator/setMatchDetailsEx", props.panelMembers === true ? authContext.tokenPanel : authContext.token, { match_id: match_id, match_details_ex: { ...match_details_ex }, subtournament_id: props.openModalmatch_details_ex.subtournament_id, ...jsonUpdateScore }, function (response, logout) {
      if (logout === 1) {


      } else if (response && response.status && Number(response.status) === 200) {
        addToast(response.data.message, { appearance: 'success' });
        if (mtype === 2) {
          // aktualizacja wyniku pojedynku
          //exitModal()
          authContext.changeRefreshView(authContext.refreshView + 1)
        } else {
          if (mtype === 1) {
            authContext.changeRefreshView(authContext.refreshView + 1)
          } else {
            authContext.changeRefreshView(authContext.refreshView + 1)
          }

        }

      } else {
        if (logout === 101) {
          addToast(response, { appearance: 'info' });
        } else if (logout === 102) {
          addToast(response, { appearance: 'warning' });
        } else {
          addToast(response, { appearance: 'error' });
        }
      }
      setloading(false)

    });
  }


  function restoreStats() {

    confirmAlert({
      title: 'Proszę potwierdzić',
      message: 'Czy chcesz zresetować statystyki dla tego pojedynku?',
      buttons: [
        {
          label: 'Tak',
          onClick: () => restoreStatsacc()
        },
        {
          label: 'Nie',
          onClick: () => ''
        }
      ]
    });

    function restoreStatsacc() {

      let match_id = props.openModalmatch_details_ex.row.subtournament_league_match_id ? props.openModalmatch_details_ex.row.subtournament_league_match_id : props.openModalmatch_details_ex.row.match_id
      setloading(true)
      ConnectWS(props.panelMembers === true ? "/external_panel/setMatchDetailsEx" : "/generator/setMatchDetailsEx", props.panelMembers === true ? authContext.tokenPanel : authContext.token, { match_id: match_id, match_details_ex: null, subtournament_id: props.openModalmatch_details_ex.subtournament_id }, function (response, logout) {
        if (logout === 1) {


        } else if (response && response.status && Number(response.status) === 200) {
          addToast(response.data.message, { appearance: 'success' });
          exitModal()
          authContext.changeRefreshView(authContext.refreshView + 1)
        } else {
          if (logout === 101) {
            addToast(response, { appearance: 'info' });
          } else if (logout === 102) {
            addToast(response, { appearance: 'warning' });
          } else {
            addToast(response, { appearance: 'error' });
          }
        }
        setloading(false)

      });
    }
  }


  function getReportMatch(match_info) {
    try {

      if (match_info && match_info.match_report.value) {
        return <div style={{ position: "absolute", bottom: 5, right: 5 }} ><a rel="noreferrer" href={match_info.match_report.value} target='_blank'><Label size='mini' color='green'><Icon name={match_info.match_report.icon} />PROTOKÓŁ</Label></a></div>
      }
      return ""
    } catch (e) {
      return ""
    }
  }

  function getAlertWrongStats(stats, obj) {
    try {

      if (stats.members) {
        if (stats.version) {

        } else {
          if (obj) {
            return " - KLIKNIJ - wykryliśmy starszy typ zapisanych statystyk"
          } else {
            return true
          }

        }
      }
      if (obj) {
        return ""
      } else {
        return false
      }
    } catch (e) {
      return false
    }
  }


  function getLinkMatche() {
    if (props.openModalmatch_details_ex.open) {
      let jsonData = {
        tournament_id: props.tournamentJson.tournament_id,
        subtournament_id: props.openModalmatch_details_ex.st.subtournament_id,
        subtournament_match_id: props.openModalmatch_details_ex.row.subtournament_league_match_id ? props.openModalmatch_details_ex.row.subtournament_league_match_id : props.openModalmatch_details_ex.row.match_id,
        match_member1_id: props.openModalmatch_details_ex.row.match_member1_id,
        match_member2_id: props.openModalmatch_details_ex.row.match_member2_id,
        member1_id:props.openModalmatch_details_ex.row.member1_id,
        member2_id:props.openModalmatch_details_ex.row.member2_id
      }

      let jwt = JWT.encode(jsonData, getKeyJwtTG());
      let lnk = process.env.REACT_APP_PUBLIC_URL + "/match/panel/" + jwt
      //console.log(jsonData)
      return lnk
    } else {
      return "Brak Danych"
    }

  }

  return (


    <Modal
      onClose={() => width > 900 ? exitModal() : ""}
      open={open}
      style={{ paddingBottom: 1, zoom: getZoomT(width) }}
      centered={width < 900 ? false : true}
      size='fullscreen'


    >
      <Modal.Header>
        <Grid >
          <Grid.Row >
            <Grid.Column width={12} verticalAlign="middle">
              <Header as='h2' textAlign='left'>
                <Icon name='balance scale' color="red" />

                <Header.Content>{t("WidokTurnieju.statystyki_meczow")}
                  <Header.Subheader>
                    {t("WidokTurnieju.statystyki_meczow1")}
                  </Header.Subheader>
                </Header.Content>


              </Header>
            </Grid.Column>
            <Grid.Column width={4} textAlign="right" verticalAlign="middle">
              <Image alt="logo" floated='right' style={{ maxWidth: 200, opacity: 0.2 }} centered src={LogoTeamLigaGenerator} />
            </Grid.Column>
          </Grid.Row>
        </Grid>

      </Modal.Header>
      <Modal.Content style={{ backgroundColor: "#e0e1e2" }} >

        <Modal.Description >
          {isLiveMatch && open ?
            LiveIcon3("Wyniki są prezentowane na bieżąco oraz odświeżane automatycznie co 10s. Śledź najnowsze informacje i rezultaty.")
            : ""}

          {globalCFGStats && open  ? <EditLeagueGlobalStats systemId={props.systemId} openModalmatch_details_ex={props.openModalmatch_details_ex} setopenModalmatch_details_ex={props.setopenModalmatch_details_ex} setOpen={setOpen} /> :  open ? <>
            {open && props.openModalmatch_details_ex && props.openModalmatch_details_ex.row ?
              <>
                <Grid unstackable style={{ margin: 0, padding: 0, marginTop: 10, marginBottom: 20 }}>
                  <Grid.Row verticalAlign='middle' style={{ margin: 0, padding: 0 }}>
                    {props.openModalmatch_details_ex.onlyView === 0 ?
                      <Grid.Column width={3}  >
                        <AIGetStatsEX panelMembers={props.panelMembers} subtournament_id={props.openModalmatch_details_ex.subtournament_id} row={props.openModalmatch_details_ex.row} match_details_ex={match_details_ex} setmatch_details_ex={setmatch_details_ex} />

                      </Grid.Column>
                      : ""}
                    <Grid.Column width={props.openModalmatch_details_ex.onlyView === 0 ? 13 : 16} style={{ margin: 0, padding: 0 }} >

                      <Grid unstackable style={{ margin: 0, padding: 0 }}>
                        <Grid.Row verticalAlign='middle' style={{ margin: 0, padding: 0 }}>
                          {props.systemId === 4 && props.openModalmatch_details_ex.onlyView === 0  ?
                            <Grid.Column width={5}  >
                              <Segment textAlign='center'>
                                <div style={{ fontSize: 13, marginBottom: 10 }}> Rozpocznij mecz na innym urządzeniu, zeskanuj qrcode lub kliknij go w celu skopiowania linku</div>

                                <QRCodeSVG value={(getLinkMatche())} className='cursorPointer' onClick={(e, i) => navigator.clipboard.writeText(getLinkMatche())} />
                              </Segment>
                            </Grid.Column>
                            : ""}
                          <Grid.Column width={props.systemId === 4 && props.openModalmatch_details_ex.onlyView === 0  ? 11 : 16}>
                            <Segment  >
                              <Grid unstackable style={{ margin: 0, padding: 0, marginTop: 10, marginBottom: 20 }}>
                                <Grid.Row verticalAlign='middle' stretched style={{ margin: 0, padding: 0 }}>
                                  <Grid.Column width={5} textAlign={width < 800 ? "left" : "right"} >
                                    <div style={{ marginLeft: 10, marginTop: 10 }} className='imgPlayer2'><ShowImgAvatar urlpic={props.openModalmatch_details_ex.row.member1_img_file} mtype={"TEAM"} msize={width < 500 ? 'massive' : width < 800 ? 'massive' : 'large'} /></div>
                                  </Grid.Column>
                                  <Grid.Column width={6} textAlign='center' style={{ fontSize: 30 }}>
                                    {scoreMatches.set_match_score ? <> {scoreMatches.member1_score}:{scoreMatches.member2_score}</> : props.openModalmatch_details_ex.row.member1_score !== null && props.openModalmatch_details_ex.row.member2_score !== null ? <>
                                      {props.openModalmatch_details_ex.row.member1_score}:{props.openModalmatch_details_ex.row.member2_score}
                                    </> : <>-:-</>}
                                    <Container textAlign='center'>{getMatchDetails(props.openModalmatch_details_ex.row.match_member1_id, props.openModalmatch_details_ex.row.match_member2_id)}</Container>


                                  </Grid.Column>
                                  <Grid.Column width={5} textAlign={width < 800 ? "right" : "left"}>
                                    <div style={{ marginRight: 10, marginTop: 10 }} className='imgPlayer2'><ShowImgAvatar urlpic={props.openModalmatch_details_ex.row.member2_img_file} mtype={"TEAM"} msize={width < 500 ? 'massive' : width < 800 ? 'massive' : 'large'} /></div>
                                  </Grid.Column>
                                </Grid.Row>
                                <Grid.Row style={{ margin: 0, padding: 0, marginTop: 5 }}>
                                  <Grid.Column width={16} textAlign='center'>
                                    <b>{getlinkplayerprofile(props.openModalmatch_details_ex.row.member1_id, props.openModalmatch_details_ex.row.member1_name, 1, 20)}</b> VS <b>{getlinkplayerprofile(props.openModalmatch_details_ex.row.member2_id, props.openModalmatch_details_ex.row.member2_name, 1, 20)}</b>
                                    <br />

                                  </Grid.Column>
                                </Grid.Row>
                              </Grid>
                              {getReportMatch(props.openModalmatch_details_ex.row.match_info)}
                            </Segment>
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>

                    </Grid.Column>

                  </Grid.Row>
                </Grid>
                  
                {match_details_ex_type === 1 ? <>
                  <EditLeagueMatchDetailsExMatcheTs st={props.openModalmatch_details_ex.st} onlyView={props.openModalmatch_details_ex.onlyView} row={props.openModalmatch_details_ex.row} members={props.openModalmatch_details_ex.st.members} match_details_ex={match_details_ex} setmatch_details_ex={setmatch_details_ex} />
                </> : match_details_ex_type === 2 ? <>

                  <EditLeagueMatchDetailsExMatcheVersion2 onlyView={props.openModalmatch_details_ex.onlyView} row={props.openModalmatch_details_ex.row} members={props.openModalmatch_details_ex.st.members} match_details_ex={match_details_ex} setmatch_details_ex={setmatch_details_ex} />
                </> : match_details_ex_type === "fiba" ? <>
                  <EditLeagueMatchDetailsExMatcheFiba onlyView={props.openModalmatch_details_ex.onlyView} row={props.openModalmatch_details_ex.row} members={props.openModalmatch_details_ex.st.members} match_details_ex={match_details_ex} setmatch_details_ex={setmatch_details_ex} />
                </> :
                  <Grid stackable style={{ marginBottom: 10 }}>
                    <Grid.Row>
                      <Grid.Column width={width < 1100 ? 16 : 8} textAlign='center' >
                        {getAllMembers(props.openModalmatch_details_ex.row.member1_id, props.openModalmatch_details_ex.row.member1_img_file, 1)}
                      </Grid.Column>

                      <Grid.Column width={width < 1100 ? 16 : 8} textAlign='center' >
                        <div style={{ marginTop: width < 1100 ? 20 : 0 }}>
                          {getAllMembers(props.openModalmatch_details_ex.row.member2_id, props.openModalmatch_details_ex.row.member2_img_file, 2)}
                        </div>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                }

              </>
              : ""}

            {props.openModalmatch_details_ex.onlyView === 1 || !match_details_ex ? "" : isAS ?
              checkIsEnabledSaveScore() && (props.systemId === 4 || props.systemId === 9) ?
                <Grid>
                  <Grid.Row columns={2}>
                    <Grid.Column>
                      <Button color='green' size='mini' fluid disabled={loading} onClick={() => saveDBData(1)}>ZAPISZ STATYSTYKI</Button>

                    </Grid.Column>
                    <Grid.Column>
                      <Button color='green' size='mini' fluid disabled={loading} onClick={() => saveDBData(2)}>ZAPISZ STATYSTYKI I ZAKTUALIZUJ WYNIK POJEDYNKU</Button>

                    </Grid.Column>
                  </Grid.Row>
                </Grid>

                : <Button color='green' fluid size='mini' loading={loading} disabled={loading} onClick={() => saveDBData(3)}>ZAPISZ</Button>




              : <>
                <Button size='mini' fluid color='green' disabled={true} >ZAPISZ</Button>
              </>}


            {isAS || props.openModalmatch_details_ex.onlyView === 1 ? "" : props.ttype !== "LEAGUE" ? noGoldIsActive() : noSubIsActive()}
            {props.openModalmatch_details_ex.onlyView === 1 || props.panelMembers === true ? "" : match_details_ex ?


              <Message size='mini' info>
                Potrzebujesz dodać inne statystyki dla zawodników? Nie ma problemu! Napisz do Nas, informacje dostępne w zakładce <span className='tllink cursorPointer' onClick={() => history.push("/kontakt")} >KONTAKT</span>
              </Message>


              :
              <Message size='mini' info>
                Brak włączonych statystyk dla tej ligi! Napisz do Nas, informacje dostępne w zakładce <span className='tllink cursorPointer' onClick={() => history.push("/kontakt")} >KONTAKT</span>
              </Message>
            }
          </> : ""}
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        {globalCFGStats ? <Button size="tiny" floated='left' onClick={() => setGlobalCFGStats(false)} content={"WSTECZ"} />
          : props.openModalmatch_details_ex.onlyView === 1 ? "" : match_details_ex ? <><Button size="tiny" color={getAlertWrongStats(match_details_ex, false) ? "red" : "grey"} floated='left' onClick={() => restoreStats()} content={t("ResetStats").toLocaleUpperCase() + getAlertWrongStats(match_details_ex, true)} /> {props.panelMembers === true ? "" : getModyfiJsonStats(props)}</> : ""}
        <Button size="tiny" labelPosition='right' icon='close' color='grey' onClick={() => exitModal()} content={t("ZAMKNIJ")} />
      </Modal.Actions>
    </Modal>



  )
}

export default EditLeagueMatchDetailsEx;


export function getScoreMatch(match_details_ex) {
  try {
    let member1_score = 0
    let member2_score = 0
    // ogólne statystyki
    if (match_details_ex.members && match_details_ex.members.points_scored_goals) {
      if (match_details_ex.members.points_scored_goals.team1_members && match_details_ex.members.points_scored_goals.team1_members.length > 0) {
        match_details_ex.members.points_scored_goals.team1_members.forEach(row => {
          if (row.value) {
            member1_score = member1_score + Number(row.value)
          }
        })
      }
      if (match_details_ex.members.points_scored_goals.team2_members && match_details_ex.members.points_scored_goals.team2_members.length > 0) {
        match_details_ex.members.points_scored_goals.team2_members.forEach(row => {
          if (row.value) {
            member2_score = member2_score + Number(row.value)
          }
        })
      }

    }

    if (match_details_ex.members && match_details_ex.members.points_scored_own_goals) {
      if (match_details_ex.members.points_scored_own_goals.team1_members && match_details_ex.members.points_scored_own_goals.team1_members.length > 0) {
        match_details_ex.members.points_scored_own_goals.team1_members.forEach(row => {
          if (row.value) {
            member2_score = member2_score + Number(row.value)
          }
        })
      }
      if (match_details_ex.members.points_scored_own_goals.team2_members && match_details_ex.members.points_scored_own_goals.team2_members.length > 0) {
        match_details_ex.members.points_scored_own_goals.team2_members.forEach(row => {
          if (row.value) {
            member1_score = member1_score + Number(row.value)
          }
        })
      }

    }

    //koszykówka i inne
    if (match_details_ex.members && match_details_ex.members.points_scored) {
      if (match_details_ex.members.points_scored.team1_members && match_details_ex.members.points_scored.team1_members.length > 0) {
        match_details_ex.members.points_scored.team1_members.forEach(row => {
          if (row.value) {
            member1_score = member1_score + Number(row.value)
          }
        })
      }


    }

    if (match_details_ex.members && match_details_ex.members.points_scored) {
      if (match_details_ex.members.points_scored.team2_members && match_details_ex.members.points_scored.team2_members.length > 0) {
        match_details_ex.members.points_scored.team2_members.forEach(row => {
          if (row.value) {
            member2_score = member2_score + Number(row.value)
          }
        })
      }


    }
    // fiba

    if (match_details_ex.fiba && match_details_ex.dataJson) {
      if (match_details_ex.dataJson.team1_scores && match_details_ex.dataJson.team1_scores.final_score) {
        member1_score = Number(match_details_ex.dataJson.team1_scores.final_score)
      }
      if (match_details_ex.dataJson.team2_scores && match_details_ex.dataJson.team2_scores.final_score) {
        member2_score = Number(match_details_ex.dataJson.team2_scores.final_score)
      }

    }

    return { set_match_score: true, member1_score: member1_score, member2_score: member2_score }
  } catch (e) {
    console.log(e)
    return { set_match_score: false, member1_score: null, member2_score: null }
  }
}